
import axios from 'axios';
import config from '../../config';
import { Error, API } from './base';


class Entity {
    constructor(name, endpoints){
        this.name = name
        this.endpoints = endpoints
    }
}


class EntitiesAPI extends API {

    constructor(token, idApp) {
        super(token);
        this.idApp = idApp;
    }

    url() {
        return config.get("re.url") + "entities";
    }
    baseUrl() {
        return config.get("re.domain");
    }

    

    urlSwagger() {
        return config.get("re.url") + "swagger";
    }


    getAll(fullAccountApplicationId) {
        return new Promise((resolve, reject) => {
            axios.get(
                `${this.baseUrl()}${fullAccountApplicationId}/catalogs/uris`,
                this._getHeaders(),

            ).then(response => {
                if (response.status>=200 && response.status<300) {
                    const entities = [];
                    Object.keys(response.data).forEach(a => {
                        entities.push(new Entity(a, response.data[a]));
                    });
                    resolve(entities);
                } else {
                    const err = new Error(response.status, "Failed to fetch entities", JSON.stringify(response.data));
                    reject(err);
                }

            }).catch(err => {
                reject(err);
            });
        })
    }
    getFullDescription(fullAccountApplicationId, entityId) {
        return new Promise((resolve, reject) => {
            axios.get(
                `${this.baseUrl()}${fullAccountApplicationId}/entity-describe/${entityId}`,
                this._getHeaders(),

            ).then(response => {
                if (response.status>=200 && response.status<300) {
                    resolve(response.data);
                } else {
                    const err = new Error(response.status, "Failed to fetch Full Description", JSON.stringify(response.data));
                    reject(err);
                }

            }).catch(err => {
                reject(err);
            });
        })
    }

    getBasicDescription(fullAccountApplicationId, entityId) {
        return new Promise((resolve, reject) => {
            axios.get(
                `${this.baseUrl()}${fullAccountApplicationId}/entity-describe/${entityId}/reduced`,
                this._getHeaders(),

            ).then(response => {
                if (response.status>=200 && response.status<300) {
                    resolve(response.data);
                } else {
                    const err = new Error(response.status, "Failed to fetch Basic Description", JSON.stringify(response.data));
                    reject(err);
                }

            }).catch(err => {
                reject(err);
            });
        })
    }

    get(id) {
        return new Promise((resolve, reject) => {
            axios.get(
              this.url() + "/"+ id,
              this._getHeaders(),

            ).then(response => {
                if (response.status === 200) {
                    resolve(new Entity(response.data.entities));
                } else {
                    const err = new Error(response.status, "Failed to fetch Entity", JSON.stringify(response.data));
                    reject(err);
                }

            }).catch(err => {
                reject(err);
            });
        })
    }

    update(Entity) {
        return new Promise((resolve, reject) => {
            axios.patch(
                this.url() + Entity.id,
                Entity,
                this._getHeaders(),
            ).then(response => {
                if (response.status >= 200 && response.status < 400) {
                    resolve();
                } else {
                    const err = new Error(response.status, "Failed to update Entity", JSON.stringify(response.data));
                    reject(err);
                }
            }).catch(err => {
                reject(err);
            });
        });
    }

    delete(id) {
        return new Promise((resolve, reject) => {
            axios.delete(
                this.url() +"/"+ id,
                this._getHeaders(),
            ).then(response => {
                if (response.status >= 200 && response.status < 400) {
                    resolve();
                } else {
                    const err = new Error(response.status, "Failed to delete Entity", JSON.stringify(response.data));
                    reject(err);
                }
            }).catch(err => {
                reject(err);
            });
        });
    }

    create(Entity) {
        return new Promise((resolve, reject) => {
            axios.post(
                this.url(),
                Entity,
                this._getHeaders(),
            ).then(response => {
                if (response.status === 201) {
                    resolve(new Entity(response.data.Entity));
                } else {
                    const err = new Error(response.status, "Failed to create Entity", JSON.stringify(response.data));
                    reject(err);
                }
            }).catch(err => {
                reject(err);
            });
        });
    }

    getSwagger() {
        return new Promise((resolve, reject) => {
            axios.get(
                this.urlSwagger() + "/catalog-endpoints",
                this._getHeaders(),

            ).then(response => {
                if (response.status === 200) {
                    const engines = [];
                    response.data.forEach(a => {
                      engines.push(new Entity(a));
                    });
                    resolve(engines);
                } else {
                    const err = new Error(response.status, "Failed to fetch engines", JSON.stringify(response.data));
                    reject(err);
                }

            }).catch(err => {
                reject(err);
            });
        })
    }

}

export {
    EntitiesAPI, Entity
};